import React from 'react';
import { LuChevronRight } from 'react-icons/lu';

export default function MaintenanceLogisticsDashboard() {
  // Data for Upcoming Maintenance Table
  const upcomingMaintenance = [
    { equipment: 'Grill – Char Broiler', location: 'Kitchen', dueDate: '22 Jul 2026', type: 'Planned' },
    { equipment: 'Walk-in Fridge', location: 'Kitchen', dueDate: '24 Jul 2026', type: 'Planned' },
    { equipment: 'Dishwasher', location: 'Kitchen', dueDate: '25 Jul 2026', type: 'Planned' },
    { equipment: 'Kettle – Large', location: 'Kitchen', dueDate: '28 Jul 2026', type: 'Preventive' },
    { equipment: 'Extractor Fan – Kitchen', location: 'Kitchen', dueDate: '30 Jul 2026', type: 'Preventive' },
  ];

  // Data for Out of Service / Issues Table
  const outOfServiceIssues = [
    { equipment: 'Ice Machine', location: 'Bar Area', reason: 'Faulty', since: '16 Jul 2026' },
    { equipment: 'Hand Dryer (Male Toilets)', location: 'Front of House', reason: 'Under repair', since: '17 Jul 2026' },
  ];

  // Data for Equipment by Location Table
  const equipmentByLocation = [
    { location: 'Kitchen', total: 36, inService: 31, outOfService: 1, maintenanceDue: 3 },
    { location: 'Bar Area', total: 12, inService: 10, outOfService: 1, maintenanceDue: 1 },
    { location: 'Front of House', total: 8, inService: 8, outOfService: 0, maintenanceDue: 0 },
    { location: 'Store Room', total: 4, inService: 3, outOfService: 0, maintenanceDue: 1 },
    { location: 'Office', total: 2, inService: 2, outOfService: 0, maintenanceDue: 0 },
  ];

  return (
    <div className="w-full bg-slate-50 p-6 font-sans">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 max-w-[1800px] mx-auto items-start">
        
        {/* Card 1: Upcoming Maintenance */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[380px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">
              Upcoming Maintenance
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-2.5 rounded-l-lg w-[35%]">EQUIPMENT</th>
                    <th className="p-2.5">LOCATION</th>
                    <th className="p-2.5">DUE DATE</th>
                    <th className="p-2.5 rounded-r-lg">TYPE</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-semibold text-slate-700 divide-y divide-slate-50">
                  {upcomingMaintenance.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-2.5 font-bold text-slate-800">{row.equipment}</td>
                      <td className="p-2.5 text-slate-600">{row.location}</td>
                      <td className="p-2.5 text-slate-900 font-medium">{row.dueDate}</td>
                      <td className="p-2.5 text-slate-600 font-normal">{row.type}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all upcoming</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

        {/* Card 2: Out of Service / Issues */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[380px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">
              Out of Service / Issues
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-2.5 rounded-l-lg w-[35%]">EQUIPMENT</th>
                    <th className="p-2.5">LOCATION</th>
                    <th className="p-2.5">REASON</th>
                    <th className="p-2.5 rounded-r-lg">SINCE</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-semibold text-slate-700 divide-y divide-slate-50">
                  {outOfServiceIssues.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-2.5 font-bold text-slate-800">{row.equipment}</td>
                      <td className="p-2.5 text-slate-600">{row.location}</td>
                      <td className="p-2.5 text-slate-600">{row.reason}</td>
                      <td className="p-2.5 text-slate-900 font-medium">{row.since}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all out of service</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

        {/* Card 3: Equipment by Location */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[380px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">
              Equipment by Location
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-2.5 rounded-l-lg w-[30%]">LOCATION</th>
                    <th className="p-2.5 text-center">TOTAL</th>
                    <th className="p-2.5 text-center">IN SERVICE</th>
                    <th className="p-2.5 text-center">OUT OF SERVICE</th>
                    <th className="p-2.5 text-center rounded-r-lg">MAINTENANCE DUE</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-semibold text-slate-700 divide-y divide-slate-50">
                  {equipmentByLocation.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-2.5 font-bold text-slate-800">{row.location}</td>
                      <td className="p-2.5 text-center font-bold text-slate-900">{row.total}</td>
                      <td className={`p-2.5 text-center font-bold ${row.inService > 0 ? 'text-emerald-600' : 'text-slate-400'}`}>{row.inService}</td>
                      <td className={`p-2.5 text-center font-bold ${row.outOfService > 0 ? 'text-rose-600' : 'text-slate-400'}`}>{row.outOfService}</td>
                      <td className={`p-2.5 text-center font-bold ${row.maintenanceDue > 0 ? 'text-orange-400' : 'text-indigo-950'}`}>{row.maintenanceDue}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all locations</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

      </div>
    </div>
  );
}
